// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f9fc;
}

.login-box {
  background-color: #fff;
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.login-box h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
}

.login-input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.login-input:focus {
  outline: none;
  border-color: #007bff;
}

.login-button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}

.login-button:hover {
  background-color: #0056b3;
}

.login-error {
  color: red;
  margin-top: 10px;
}

.signup-link {
  margin-top: 10px;
  font-size: 14px;
  color: #555;
}

.signup-link a {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}

.signup-link a:hover {
  text-decoration: underline;
}

/****    SignUp.css      ****/

/* Container styles */
.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f9fc; /* Same as login page */
}

/* Box styles */
.signup-box {
  background-color: #fff;
  padding: 50px 40px; /* Larger padding for sign-up forms */
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Slightly stronger shadow */
  text-align: center;
  max-width: 400px;
  width: 100%;
}

/* Header styles */
.signup-box h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 28px; /* Slightly larger font size */
  font-weight: bold;
}

/* Input styles */
.signup-input {
  width: 100%;
  padding: 10px;
  margin: 12px 0;
  border: 1px solid #ccc; /* Softer border color */
  border-radius: 4px;
  font-size: 16px;
}

.signup-input:focus {
  outline: none;
  border-color: #28a745; /* Green border for focus */
}

/* Button styles */
.signup-button {
  width: 100%;
  padding: 14px;
  background-color: #28a745; /* Green button for sign up */
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  font-weight: bold;
}

.signup-button:hover {
  background-color: #218838;
}

/* Error and success messages */
.signup-error {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}

.signup-success {
  color: rgb(2, 104, 2);
  margin-top: 10px;
  font-size: 14px;
}

/* Link back to login */
.login-link {
  margin-top: 20px;
  font-size: 14px;
  color: #555;
}

.login-link a {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}

.login-link a:hover {
  text-decoration: underline;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Authorization mesaj kismina stil ekleme .. */
.auth-message {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  transition: all 0.3s ease;
}

.auth-message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.auth-message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}


/*Authorization sayfasi icin */
.authorization-container {
  padding: 20px;
  max-width: 600px;
  margin: 20px auto;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.authorization-container h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
}

.authorization-container .form-group {
  margin-bottom: 20px;
}

.authorization-container label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.authorization-container input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: border-color 0.3s ease;
}

.authorization-container input:focus {
  border-color: #007bff;
  outline: none;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

.authorization-container button {
  width: 48%;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  color: white;
}

.authorization-container button:first-child {
  background-color: #305e7a; /* Blue */
}

.authorization-container button:first-child:hover {
  background-color: #305e7a;
}

.authorization-container button:last-child {
  background-color: #305e7a; /* Matching blue */
}

.authorization-container button:last-child:hover {
  background-color: #305e7a;
}

.auth-message {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
  text-align: center;
}

.auth-message.success {
  background-color: #d4edda; /* Light green */
  color: #155724; /* Dark green */
  border: 1px solid #c3e6cb;
}

.auth-message.error {
  background-color: #f8d7da; /* Light red */
  color: #721c24; /* Dark red */
  border: 1px solid #f5c6cb;
}

.tenant-orch-id {
  display: block;
  font-size: 0.9em;
  color: #666;
  margin-top: 4px;
}

/* Tab container styles */
/* Update the tab container styles to match dashboard theme */
.tab-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.tab-container button {
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #305e7a;
  color: white;
  transition: background-color 0.3s ease;
  width: auto;
}

.tab-container button.active {
  background-color: #dd6e25;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.tab-container button:hover:not(.active) {
  background-color: #417ca0;
}

/* Update authorization container */
.authorization-container {
  padding: 10px 10px 20px 20px;
  max-width: 1000px;
  margin: 20px auto;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Update buttons */
.authorization-container button {
  background-color: #305e7a;
  color: white;
  transition: background-color 0.3s ease;
}

.authorization-container button:hover {
  background-color: #dd6e25;
}

/* Update form inputs */
.authorization-container input:focus {
  border-color: #305e7a;
  outline: none;
}

/* Update success/error messages */
.auth-message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.auth-message.error {
  background-color: #f8d7da;
  color: #741c25;
  border: 1px solid #f5c6cb;
}

.tenant-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  width: 100%;
  max-width: 800px;
}

.tenant-card {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tenant-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.tenant-name {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.tenant-orch-id {
  font-size: 14px;
  color: #666;
  margin-left: 12px;
}

.tenant-url {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.tenant-url a {
  color: #3498db;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tenant-url a:hover {
  text-decoration: underline;
}

.tenant-actions {
  display: flex;
  gap: 8px;
}

.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  gap: 10px;
  margin-right: 10px;
}

.icon-btn:hover {
  background-color: #f5f5f5;
}

.delete-btn:hover {
  background-color: #c53232;
}

/* Styles for editing state */
.tenant-card input {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 14px;
}

.tenant-card input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

/* Add tenant section styles */
.add-tenant {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.add-tenant input {
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.add-tenant input:focus {
  border-color: #305e7a;
  outline: none;
  box-shadow: 0 0 0 2px rgba(48, 94, 122, 0.1);
}

.add-tenant button {
  margin-top: 10px;
  padding: 12px;
  background-color: #305e7a;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-tenant button:hover {
  background-color: #dd6e25;
}

.add-tenant button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.select-environment {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  transition: border-color 0.3s ease;
}

.select-environment:focus {
  border-color: #305e7a;
  outline: none;
  box-shadow: 0 0 0 2px rgba(48, 94, 122, 0.1);
}
.authorization-content .form-group {
  margin-bottom: 16px;
}

.authorization-content input,
.authorization-content select {
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);
}
`, "",{"version":3,"sources":["webpack://./src/styles/Auth.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;;AAE7B,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,kBAAkB,EAAE,qCAAqC;EACzD,kBAAkB;EAClB,0CAA0C,EAAE,6BAA6B;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe,EAAE,8BAA8B;EAC/C,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB,EAAE,wBAAwB;EAChD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB,EAAE,6BAA6B;EACxD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;;AAGA,8BAA8B;AAC9B;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,eAAe;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,cAAc,EAAE,aAAa;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,4CAA4C;AAC9C","sourcesContent":["/* Login.css */\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f7f9fc;\n}\n\n.login-box {\n  background-color: #fff;\n  padding: 40px 30px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.login-box h2 {\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 24px;\n}\n\n.login-input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.login-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #007bff;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.login-button:hover {\n  background-color: #0056b3;\n}\n\n.login-error {\n  color: red;\n  margin-top: 10px;\n}\n\n.signup-link {\n  margin-top: 10px;\n  font-size: 14px;\n  color: #555;\n}\n\n.signup-link a {\n  color: #007bff;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.signup-link a:hover {\n  text-decoration: underline;\n}\n\n/****    SignUp.css      ****/\n\n/* Container styles */\n.signup-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f7f9fc; /* Same as login page */\n}\n\n/* Box styles */\n.signup-box {\n  background-color: #fff;\n  padding: 50px 40px; /* Larger padding for sign-up forms */\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Slightly stronger shadow */\n  text-align: center;\n  max-width: 400px;\n  width: 100%;\n}\n\n/* Header styles */\n.signup-box h2 {\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 28px; /* Slightly larger font size */\n  font-weight: bold;\n}\n\n/* Input styles */\n.signup-input {\n  width: 100%;\n  padding: 10px;\n  margin: 12px 0;\n  border: 1px solid #ccc; /* Softer border color */\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.signup-input:focus {\n  outline: none;\n  border-color: #28a745; /* Green border for focus */\n}\n\n/* Button styles */\n.signup-button {\n  width: 100%;\n  padding: 14px;\n  background-color: #28a745; /* Green button for sign up */\n  border: none;\n  border-radius: 4px;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 20px;\n  font-weight: bold;\n}\n\n.signup-button:hover {\n  background-color: #218838;\n}\n\n/* Error and success messages */\n.signup-error {\n  color: red;\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n.signup-success {\n  color: rgb(2, 104, 2);\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n/* Link back to login */\n.login-link {\n  margin-top: 20px;\n  font-size: 14px;\n  color: #555;\n}\n\n.login-link a {\n  color: #007bff;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.login-link a:hover {\n  text-decoration: underline;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n/* Authorization mesaj kismina stil ekleme .. */\n.auth-message {\n  margin-top: 15px;\n  padding: 10px;\n  border-radius: 5px;\n  font-weight: bold;\n  text-align: center;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.auth-message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.auth-message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n\n/*Authorization sayfasi icin */\n.authorization-container {\n  padding: 20px;\n  max-width: 600px;\n  margin: 20px auto;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.authorization-container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.authorization-container .form-group {\n  margin-bottom: 20px;\n}\n\n.authorization-container label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #333;\n}\n\n.authorization-container input {\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  transition: border-color 0.3s ease;\n}\n\n.authorization-container input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.button-group {\n  display: flex;\n  justify-content: space-between;\n}\n\n.authorization-container button {\n  width: 48%;\n  padding: 10px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  color: white;\n}\n\n.authorization-container button:first-child {\n  background-color: #305e7a; /* Blue */\n}\n\n.authorization-container button:first-child:hover {\n  background-color: #305e7a;\n}\n\n.authorization-container button:last-child {\n  background-color: #305e7a; /* Matching blue */\n}\n\n.authorization-container button:last-child:hover {\n  background-color: #305e7a;\n}\n\n.auth-message {\n  margin-top: 15px;\n  padding: 10px;\n  border-radius: 5px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.auth-message.success {\n  background-color: #d4edda; /* Light green */\n  color: #155724; /* Dark green */\n  border: 1px solid #c3e6cb;\n}\n\n.auth-message.error {\n  background-color: #f8d7da; /* Light red */\n  color: #721c24; /* Dark red */\n  border: 1px solid #f5c6cb;\n}\n\n.tenant-orch-id {\n  display: block;\n  font-size: 0.9em;\n  color: #666;\n  margin-top: 4px;\n}\n\n/* Tab container styles */\n/* Update the tab container styles to match dashboard theme */\n.tab-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.tab-container button {\n  padding: 12px 24px;\n  font-size: 16px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: #305e7a;\n  color: white;\n  transition: background-color 0.3s ease;\n  width: auto;\n}\n\n.tab-container button.active {\n  background-color: #dd6e25;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.tab-container button:hover:not(.active) {\n  background-color: #417ca0;\n}\n\n/* Update authorization container */\n.authorization-container {\n  padding: 10px 10px 20px 20px;\n  max-width: 1000px;\n  margin: 20px auto;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Update buttons */\n.authorization-container button {\n  background-color: #305e7a;\n  color: white;\n  transition: background-color 0.3s ease;\n}\n\n.authorization-container button:hover {\n  background-color: #dd6e25;\n}\n\n/* Update form inputs */\n.authorization-container input:focus {\n  border-color: #305e7a;\n  outline: none;\n}\n\n/* Update success/error messages */\n.auth-message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.auth-message.error {\n  background-color: #f8d7da;\n  color: #741c25;\n  border: 1px solid #f5c6cb;\n}\n\n.tenant-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 20px;\n  width: 100%;\n  max-width: 800px;\n}\n\n.tenant-card {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.tenant-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.tenant-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.tenant-orch-id {\n  font-size: 14px;\n  color: #666;\n  margin-left: 12px;\n}\n\n.tenant-url {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #666;\n  margin-top: 8px;\n}\n\n.tenant-url a {\n  color: #3498db;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tenant-url a:hover {\n  text-decoration: underline;\n}\n\n.tenant-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  gap: 10px;\n  margin-right: 10px;\n}\n\n.icon-btn:hover {\n  background-color: #f5f5f5;\n}\n\n.delete-btn:hover {\n  background-color: #c53232;\n}\n\n/* Styles for editing state */\n.tenant-card input {\n  padding: 6px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-right: 8px;\n  font-size: 14px;\n}\n\n.tenant-card input:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n/* Add tenant section styles */\n.add-tenant {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-bottom: 20px;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.add-tenant input {\n  padding: 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.add-tenant input:focus {\n  border-color: #305e7a;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(48, 94, 122, 0.1);\n}\n\n.add-tenant button {\n  margin-top: 10px;\n  padding: 12px;\n  background-color: #305e7a;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-tenant button:hover {\n  background-color: #dd6e25;\n}\n\n.add-tenant button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.select-environment {\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: white;\n  transition: border-color 0.3s ease;\n}\n\n.select-environment:focus {\n  border-color: #305e7a;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(48, 94, 122, 0.1);\n}\n.authorization-content .form-group {\n  margin-bottom: 16px;\n}\n\n.authorization-content input,\n.authorization-content select {\n  box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
